import styled from 'styled-components';

export const EventDescriptionDetails = styled.div`
  padding: 0;
  background: #f7f7f7;
`;

export const ArticleDescription = styled.div`
  padding: 4rem 15px;
  max-width: 1000px;
  margin: 0 auto;
  display: block;
  .article_description {
    flex-direction: ${({ dir }) => (dir === 'rtl' ? 'row-reverse' : '')};
  }

  @media (max-width: 991.98px) {
    padding: 3rem 0;
  }
`;

export const Figure = styled.figure`
  position: relative;
  height: 100%;
  min-height: 150px;
  margin: 0 0 1rem;
  width: 100%;
  margin-right: ${({ dir }) => (dir === 'rtl' ? '5rem' : '')};
  @media (max-width: 991.98px) {
    margin: 0;
    padding: 0 0 1.5rem;
  }

  @media (max-width: 575.98px) {
    text-align: center;
    padding-bottom: 2rem;
    img {
      display: inline-block;
    }
  }

  figcaption {
    position: absolute;
    bottom: 0;
    width: ${({ dir }) => (dir === 'rtl' ? '100%' : '70%')};
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif' : '')};
    left: 0;
    font-weight: 400;
    color: #000;

    @media (max-width: 991.98px) {
      display: none;
    }

    &:before {
      margin-bottom: 0.5rem;
      content: '';
      display: block;
      width: ${({ dir }) => (dir === 'rtl' ? '70%' : '100%')};
      height: 2px;
      background: #1b7bdd;
    }

    span {
      color: #4a4a4a;
      font-weight: 500;
    }
  }
`;

export const DescriptionText = styled.div`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif' : '')};
  h4 {
    font-family: ${({ dir }) =>
      dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif' : 'LibreBaskervilleRegular'};
    line-height: 30px;
    color: #000;
    font-size: 22px;
    font-weight: 300;
  }
  h2 {
    margin-bottom: 2rem;
    line-height: 30px;
    color: #000;
    font-size: 22px;
  }

  p {
    font-size: 14px;
    margin-bottom: 24px;
    color: #898989;
  }
`;

export const TextToggle = styled.div`
  font-size: 14px;
  margin-bottom: 1.5rem;
  color: #898989;
  line-height: ${({ dir }) => (dir === 'rtl' ? '25px' : '')};

  .libreBaskerville {
    font-family: 'LibreBaskervilleRegular', sans-serif;
  }

  sub {
    vertical-align: baseline;
  }

  &.toggle {
    ${({ toggle }) =>
      toggle
        ? `
      animation-name: fadeDown;
      animation-duration: 800ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
      `
        : `
      animation-name: fadeUp;
      animation-duration: 800ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
      `}

    @media (min-width: 576px) {
      animation: none;
    }
  }

  @keyframes fadeUp {
    0% {
      height: fit-content;
      margin-bottom: 1.5rem;
      opacity: 1;
    }

    100% {
      opacity: 0;
      background: transparent;
      overflow: hidden;
      margin: 0;
      height: 0;
    }
  }

  @keyframes fadeDown {
    0% {
      background: transparent;
      overflow: hidden;
      margin: 0;
      height: 0;
      opacity: 0;
    }

    100% {
      height: fit-content;
      margin-bottom: 1.5rem;
      opacity: 1;
    }
  }
`;

export const ReadMoreLabel = styled.button`
  background-color: transparent;
  background-position: 0% 0%;
  border: none;
  color: #898989;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  text-decoration: underline;
  word-spacing: 0px;
  margin-top: 0.5rem;
  padding-left: 0px;
  padding-right: 0px;

  &[dir='ltr'] {
    font-family: 'DINRegular';
  }
  &[dir='rtl'] {
    font-family: 'GESSTwoDWTCLight,sans-serif';
  }

  @media (min-width: 576px) {
    display: none;
  }
`;
export const AudienceIcon = styled.div`
  background-image: url(/svg/sprites.svg#audience);
  width: 76px;
  height: 36px;
`;
